import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { getRoleAPI } from "api";
//i18n
import { withTranslation } from "react-i18next";

const linkList = [
  {
    name: "Dashboard",
    description: "",
    status: true,
    path: "admin-dashboard",
    role: "ROLE0000000",
    icon: "bx bx-home-circle",
  },
  {
    name: "Manage Party",
    description: "",
    path: "Manage-Party",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-home-circle",
    modules: [
      {
        name: "Add Party",
        description: "",
        path: "add-party",
        status: true,
      },
      {
        name: "Party List",
        description: "",
        path: "party-list",
        status: true,
      },
    ],
  },
  {
    name: "Manage Party",
    description: "",
    path: "Manage-Party",
    status: true,
    role: "ROLE0000007",
    icon: "bx bx-home-circle",
    modules: [
      {
        name: "Add Party",
        description: "",
        path: "add-party",
        status: true,
      },
      {
        name: "Party List",
        description: "",
        path: "party-list",
        status: true,
      },
    ],
  },
  {
    hidden: true,
    name: "Manage Party",
    description: "",
    path: "Manage-Party",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-home-circle",
    modules: [
      {
        name: "Add Party",
        description: "",
        path: "add-party",
        status: true,
      },
      {
        name: "Party List",
        description: "",
        path: "party-list",
        status: true,
      },
    ],
  },
  {
    name: "Manage Organization",
    description: "",
    path: "Manage-Organization",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-shape-circle",
    modules: [
      {
        name: "P3Y Organization Details",
        description: "",
        path: "organization-detail",
        status: true,
      },
      {
        name: "GST Rate",
        description: "",
        path: "gst-rate",
        status: true,
      },
      {
        name: "Add Factory(Unit)",
        description: "",
        path: "add-unit",
        status: true,
      },
      {
        name: "Factory List",
        description: "",
        path: "organization-partyList",
        status: true,
      },

      // {
      //   name: "Add Material Item",
      //   description: "",
      //   path: "add-material-item",
      //   status: true,
      // },
      {
        name: "Shape",
        description: "",
        path: "organization-shape",
        status: true,
      },
      {
        name: "Process",
        description: "",
        path: "organization-process",
        status: true,
      },
      {
        name: "Inclusion",
        description: "",
        path: "organization-inclusion",
        status: true,
      },
      // {
      //   name: "Category",
      //   description: "",
      //   path: "organization-category",
      //   status: true,
      // },
      {
        name: "Items",
        description: "",
        path: "organization-items",
        status: true,
      },
      {
        name: "Add Purchased Item",
        description: "",
        path: "add-purchased-item",
        status: true,
      },
      {
        name: "Material Stock",
        description: "",
        path: "party-material-stock",
        status: true,
      },
      {
        name: "Allocate Material",
        description: "",
        path: "allocate-material",
        status: true,
      },
      {
        name: "Allocate Material List",
        description: "",
        path: "allocate-material-list",
        status: true,
      },
    ],
  },  
  {
    name: "Purchase & Assign Department",
    description: "",
    path: "purchase",
    status: true,
    role: "ROLE0000008",
    icon: "bx bx-shape-circle",
    modules: [
      {
        name: "Items",
        description: "",
        path: "organization-items",
        status: true,
      },
      {
        name: "Add Purchased Item",
        description: "",
        path: "add-purchased-item",
        status: true,
      },
      {
        name: "Material Stock",
        description: "",
        path: "party-material-stock",
        status: true,
      },
      {
        name: "Allocate Material",
        description: "",
        path: "allocate-material",
        status: true,
      },
      {
        name: "Allocate Material List",
        description: "",
        path: "allocate-material-list",
        status: true,
      },
    ],
  },
  {
    name: "Manage User",
    description: "Manage User",
    path: "manage-user",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-user",
    modules: [
      {
        name: "Add User",
        description: "",
        path: "add-user",
        status: true,
      },
      {
        name: "User List",
        description: "",
        path: "user-list",
        status: true,
      },
    ],
  },
  {
    name: "Manage Stock",
    description: "Manage Stock",
    path: "manage-stock",
    status: true,
    role: "ROLE0000000",
    icon: "bx bxs-spreadsheet",
    modules: [
      {
        name: "Add Stock",
        description: "",
        path: "internal-unit-inward",
        status: true,
      },
      {
        name: "Office Stock List",
        description: "",
        path: "office-stock-list",
        status: true,
      },
      {
        name: "Outward Stock List",
        description: "",
        path: "outward-stock-list",
        status: true,
      },
      {
        name: "View Jangad Timeline",
        description: "",
        path: "view-jangad-timeline-manage-stock",
        status: true,
      },
    ],
  },
  {
    name: "Manage Stock (Sales Office)",
    description: "Manage Stock (Sales Office)",
    path: "sales-office",
    status: true,
    role: "ROLE0000007",
    icon: "bx bx-home-circle",
    modules: [
      {
        name: "Dashboard",
        description: "",
        path: "user-dashboard",
        status: true,
      },
      {
        name: "Add Stock (Inward)",
        description: "",
        path: "user-add-stock-inward",
        status: true,
      },

      // {
      //   name: "Receive External Jangad",
      //   description: "",
      //   path: "receive-external-jangad",
      //   status: true,
      // },
      // {
      //   name: "Outward Stock",
      //   description: "",
      //   path: "user-outward-stock",
      //   status: true,
      // },
      {
        name: "Office Stock List",
        description: "",
        path: "user-office-stock-list",
        status: true,
      },
      {
        name: "Outward Stock List",
        description: "",
        path: "user-outward-stock-list",
        status: true,
      },

      {
        name: "Cancel/Return Diamond",
        description: "",
        path: "rejected-diamond",
        status: true,
      },
      {
        name: "Reassign Stock (Inward)",
        description: "",
        path: "reassign-stock-inward",
        status: true,
      },
      {
        name: "Add Express (Inward)",
        description: "",
        path: "user-add-express-inward",
        status: true,
      },
      {
        name: "Express Inwards List",
        description: "",
        path: "user-express-inward-list",
        status: true,
      },
      {
        name: "View Express Inwards",
        description: "",
        path: "sales-view-express-inward",
        status: true,
        hidden: true,
      },
      {
        name: "My Profile",
        description: "",
        path: "profile",
        status: true,
      },
      {
        name: "Change Password",
        description: "",
        path: "update-password",
        status: true,
      },
    ],
  },
  {
    name: "Manage Stock (Factory Office)",
    description: "Manage Stock (Factory Office)",
    path: "data-entry",
    status: true,
    role: "ROLE0000001",
    icon: "bx bx-home-circle",
    modules: [
      {
        name: "Dashboard",
        description: "",
        path: "data-entry-dashboard",
        status: true,
      },
      {
        name: "Office Stock List",
        description: "",
        path: "data-entry-office-stock-list",
        status: true,
      },
      {
        name: "Cancel/Return Diamond",
        description: "",
        path: "rejected-diamond-grader",
        status: true,
      },
      {
        name: "Outward Stock List",
        description: "",
        path: "data-entry-outward-stock-list",
        status: true,
      },
       {
        name: "Express Inwards List ",
        description: "",
        path: "data-entry-express-inward-list",
        status: true,
      },
      {
        name: "My Profile",
        description: "",
        path: "profile",
        status: true,
      },
    ],
  },
  {
    hidden: true,
    name: "Purchase & Assign Department",
    description: "",
    path: "purchase",
    status: true,
    role: "ROLE0000007",
    icon: "bx bx-shape-circle",
    modules: [
      {
        name: "Items",
        description: "",
        path: "organization-items",
        status: true,
      },
      {
        name: "Add Purchased Item",
        description: "",
        path: "add-purchased-item",
        status: true,
      },
      {
        name: "Material Stock",
        description: "",
        path: "party-material-stock",
        status: true,
      },
      {
        name: "Allocate Material",
        description: "",
        path: "allocate-material",
        status: true,
      },
      {
        name: "Allocate Material List",
        description: "",
        path: "allocate-material-list",
        status: true,
      },
    ],
  },
  {
    name: "Purchase & Assign Department",
    description: "",
    path: "purchase",
    status: true,
    role: "ROLE0000007",
    icon: "bx bx-shape-circle",
    modules: [
      {
        name: "Items",
        description: "",
        path: "organization-items",
        status: true,
      },
      {
        name: "Add Purchased Item",
        description: "",
        path: "add-purchased-item",
        status: true,
      },
      {
        name: "Material Stock",
        description: "",
        path: "party-material-stock",
        status: true,
      },
      {
        name: "Allocate Material",
        description: "",
        path: "allocate-material",
        status: true,
      },
      {
        name: "Allocate Material List",
        description: "",
        path: "allocate-material-list",
        status: true,
      },
    ],
  },
  // {
  //   name: "Express Inwards ",
  //   description: "Express Inwards (Sales Office)",
  //   path: "sales-office",
  //   status: true,
  //   role: "ROLE0000007",
  //   icon: "bx bx-home-circle",
  //   modules: [
  //     {
  //       name: "Dashboard",
  //       description: "",
  //       path: "express-dashboard",
  //       status: true,
  //     },
      
  //     // {
  //     //   name: "Outward List",
  //     //   description: "",
  //     //   path: "user-outward-list",
  //     //   status: true,
  //     // },

  //     // {
  //     //   name: "Cancel/Return Diamond",
  //     //   description: "",
  //     //   path: "rejected-diamond",
  //     //   status: true,
  //     // },
  //     // {
  //     //   name: "Reassign Stock (Inward)",
  //     //   description: "",
  //     //   path: "reassign-stock-inward",
  //     //   status: true,
  //     // },
  //     // {
  //     //   name: "My Profile",
  //     //   description: "",
  //     //   path: "profile",
  //     //   status: true,
  //     // },
  //     // {
  //     //   name: "Change Password",
  //     //   description: "",
  //     //   path: "update-password",
  //     //   status: true,
  //     // },
  //   ],
  // },
 
  {
    name: "Grader",
    description: "Grader",
    path:"grader",
    status: true,
    role: "ROLE0000002",
    icon: "bx bxs-user",
    modules: [
      {
        name: "Dashboard",
        description: "",
        path: "grader-dashboard",
        status: true,
      },
      {
        name: "My Stock List",
        description: "",
        path: "grader-stock-list",
        status: true,
      },
      {
        name: "Assign Stock List",
        description: "",
        path: "assign-stock-list",
        status: true,
      },
      {
        name: "Processed Stock",
        description: "",
        path: "grader-processed-stock-list",
        status: true,
      },
      {
        name: "Repeat Stock List",
        description: "",
        path: "grader-repeat-stock-list",
        status: true,
      },
      {
        name: "Complete Stock List",
        description: "",
        path: "grader-complete-stock-list",
        status: true,
      },
      {
        name: "View Jangad Timeline",
        description: "",
        path: "view-jangad-timeline",
        status: true,
      },

      // {
      //   name: "Stock Accepted",
      //   description: "",
      //   path: "accepted-process-stock",
      //   status: true,
      // },
      // {
      //   name: "Clients Reject Stock",
      //   description: "",
      //   path: "client-reject-stock",
      //   status: true,
      // },
      {
        name: "My Profile",
        description: "",
        path: "profile",
        status: true,
      },
      {
        name: "Change Password",
        description: "",
        path: "update-password",
        status: true,
      },
    ],
  },
  {
    name: "Filler",
    description: "Filler",
    path:"filler",
    status: true,
    role: "ROLE0000003",
    icon: "bx bxs-user",
    modules: [
      {
        name: "Dashboard",
        description: "",
        path: "filler-dashboard",
        status: true,
      },
      {
        name: "My Stock List",
        description: "",
        path: "filler-stock-list",
        status: true,
      },
      {
        name: "Edit Filling Process",
        description: "",
        path: "filler-edit-filling-process",
        status: true,
      },
      {
        name: "Belt List",
        description: "",
        path: "cube-list",
        status: true,
      },
      {
        name: "Repeat Stock List",
        description: "",
        path: "filler-repeat-stock-list",
        status: true,
      },

      // {
      //   name: "Assigned Belt Details",
      //   description: "",
      //   path: "filler-assign-cube-detail",
      //   status: true,
      // },
      {
        name: "My Profile",
        description: "",
        path: "profile",
        status: true,
      },
      {
        name: "Change Password",
        description: "",
        path: "user-profile",
        status: true,
      },
    ],
  },
  {
    name: "Machine Operator",
    description: "Machine Operator",
    path:"machine-operator",
    status: true,
    role: "ROLE0000004",
    icon: "bx bxs-user",
    modules: [
      {
        name: "Dashboard",
        description: "",
        path: "machine-operator-dashboard",
        status: true,
      },
      {
        name: "My Belt List",
        description: "",
        path: "machine-operator-cube-list",
        status: true,
      },
      {
        name: "Stock Summary",
        description: "",
        path: "machine-operator-stock-summary",
        status: true,
      },
      {
        name: "My Profile",
        description: "",
        path: "profile",
        status: true,
      },
      {
        name: "Change Password",
        description: "",
        path: "user-profile",
        status: true,
      },
    ],
  },
  {
    name: "Party Ledger",
    description: "Employee",
    path:"internal-unit",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-home-circle",
    modules: [
      {
        name: "Party Wise Report",
        description: "",
        path: "party-wise-report",
        status: true,
      },
      // {
      //   name: "Party Wise jangad",
      //   description: "",
      //   path: "party-wise-jangad",
      //   status: true,
      // },
      {
        name: "Generate Ledger",
        description: "",
        path: "generate-Ledger",
        status: true,
      },
      {
        name: "Ledger List",
        description: "",
        path: "ledger-report",
        status: true,
      },
    ],
  },
  {
    name: "External Ledger",
    description: "Employee",
    path:"external-unit",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-home-circle",
    modules: [
      // {
      //   name: "Factory Wise Report",
      //   description: "",
      //   path: "factory-wise-report",
      //   status: true,
      // },
      {
        name: "Generate Ledger",
        description: "",
        path: "external-generate-ledger",
        status: true,
      },
      {
        name: "Ledger List",
        description: "",
        path: "external-ledger-report",
        status: true,
      },
    ],
  },
  {
    name: "Transaction History",
    description: "Employee",
    path:"transaction-history",
    status: true,
    role: "ROLE0000000",
    icon: "bx bx-transfer",
    modules: [
      {
        name: "Transaction List",
        description: "",
        path: "transaction-list",
        status: true,
      },
      {
        name: "Bank",
        description: "",
        path: "bank",
        status: true,
      },
    ],
  },
];
const userData = JSON.parse(localStorage.getItem("authUser"));


class SidebarContent extends Component {
  state = {
    roleList: [],
    moduleList: linkList.filter(x =>
      x.role == JSON.parse(localStorage.getItem("authUser")).roleId ||
      JSON.parse(localStorage.getItem("authUser")).id.includes("ADMIN")
        ? true
        : false
    ),
  };
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
    getRoleAPI()
      .then(data => {
        if (data && data.data && Array.isArray(data.data)) {
          this.setState({ roleList: data.data });
        }
      })
      .catch(err => {
        alert(err);
      });
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    for (let i = 0; i < items.length; ++i) {
      // if (this.props.location.pathname === items[i].pathname)
      if (
        this.props.location.pathname ===
        items[i].getAttribute("href").split("#")[1]
      ) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li  className="menu-title">
                {this.props.t("Menu")}
              </li>
              {this.state.moduleList.map((x, i) => { 
               if (
                  x.role == userData.roleId ||
                  (userData.id.includes("ADMIN") && x.role == "ROLE0000000")
                )
                  return (
                    <li
                      key={i + "fgdg"}
                      className={`mm-active ${x.hidden ? "d-none" : ""}`}
                    >
                      <Link to={x.path}>
                        <i
                          className={x.icon}
                          dangerouslySetInnerHTML={{ __html: x.iconSvg }}
                        />
                        <span>{this.props.t(x.name)}</span>
                      </Link>
                      {x.modules && (
                        <ul
                          key={i + "ukjj" }
                          className="sub-menu mm-collapse mm-show"
                          aria-expanded="true"
                        >
                          {x.modules.map((x, index) => {
                            return (
                              <li key={index + "knj"+i} className={`${x.hidden ? "d-none" : ""}`}>
                                <Link to={x.path}>{this.props.t(x.name)}</Link>
                                {x.modules && (
                                  <ul
                                    className="sub-menu"
                                    aria-expanded="true"
                                    key={index + "ull" + i}
                                  >
                                    {x.modules.map((x, index) => {
                                      return (
                                        <li key={index + "ll"+i} className={`${x.hidden ? "d-none" : ""}`}>
                                          <Link to={x.path}>
                                            {this.props.t(x.name)}
                                          </Link>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                else return <></>;
              })}

              {/* <li>
                <Link to="/#">
                  <i className="bx bx-home-circle" />
                  <span className="badge rounded-pill bg-info float-end">
                    04
                  </span>
                  <span>{this.props.t("Dashboards")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/dashboard">{this.props.t("Default")}</Link>
                  </li>
                  <li>
                    <Link to="/dashboard-saas">{this.props.t("Saas")}</Link>
                  </li>
                  <li>
                    <Link to="/dashboard-crypto">{this.props.t("Crypto")}</Link>
                  </li>
                  <li>
                    <Link to="/dashboard-blog">{this.props.t("Blog")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-home-circle" />
                  <span>{this.props.t("Manage Party")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/add-party">
                      {this.props.t("- Add Comapny")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/party-list">
                      {this.props.t("- Party List ")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>                             
                <Link to="/#">
                  <i className="bx bx-shape-circle"></i>
                  <span>{this.props.t("Manage Organization")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/organization-detail">
                      {this.props.t("- Organization Details")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/gst-rate">{this.props.t("- GST Rate")}</Link>
                  </li>
                  <li>
                    <Link to="/add-unit">{this.props.t("- Add Unit")}</Link>
                  </li>
                  <li>
                    <Link to="/organization-partyList">
                      {this.props.t("- Party List ")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/add-material-item">
                      {this.props.t("- Add Material Item")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/add-purchased-item">
                      {this.props.t("- Add Purchased Item")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/party-material-stock">
                      {this.props.t("- Party Material Stock")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-user"></i>
                  <span>{this.props.t("Manage User")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/add-user">{this.props.t("- Add User")}</Link>
                  </li>
                  <li>
                    <Link to="/user-list">{this.props.t("- User List")}</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bxs-spreadsheet"></i>
                  <span>{this.props.t("Manage Stock")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/#">
                      <span>{this.props.t("- Add Stock (Inward)")}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <Link to="/internal-unit-inward">
                          {this.props.t("- Internal Unit")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/external-unit-inward">
                          {this.props.t("- External Unit")}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/#">
                      <span>{this.props.t("- Outward Stock")}</span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <Link to="/internal-unit-outward">
                          {this.props.t("- Internal Unit")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/external-unit-outward">
                          {this.props.t("- External Unit")}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/office-stock-list">
                      {this.props.t("- {this.props.t('Office Stock List')}")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/outward-stock-list">
                      {this.props.t("- Outward Stock List")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#">
                  <i className="bx bxs-spreadsheet"></i>
                  <span>{this.props.t("Manage Stock (Sales Ofiice)")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/user-dashboard">
                      {this.props.t("- Dashboard")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-add-stock-inward">
                      {this.props.t("- Add Stock (Inward)")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-outward-stock">
                      {this.props.t("- Outward Stock")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-office-stock-list">
                      {this.props.t("- {this.props.t('Office Stock List')}")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-outward-stock-list">
                      {this.props.t("- Outward Stock List")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/sales-user-profile">
                      {this.props.t("- My Profile")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/sales-update-password">
                      {this.props.t("- Change Password")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#">
                  <i className="bx bxs-spreadsheet"></i>
                  <span>{this.props.t("Manage Stock (Factory Ofiice)")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/data-entry-dashboard">
                      {this.props.t("- Dashboard")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-entry-add-stock-inward">
                      {this.props.t("- Add Stock (Inward)")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-entry-outward-stock">
                      {this.props.t("- Outward Stock")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-entry-office-stock-list">
                      {this.props.t("- {this.props.t('Office Stock List')}")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-entry-outward-stock-list">
                      {this.props.t("- Outward Stock List")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-entry-user-profile">
                      {this.props.t("- My Profile")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/data-entry-update-password">
                      {this.props.t("- Change Password")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bxs-user"></i>
                  <span>{this.props.t("Grader")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/grader-dashboard">
                      {this.props.t("- Dashboard")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/grader-edit-verify-accept">
                      {this.props.t("- {this.props.t("EDIT VERIFY & ACCEPT")} ")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/grader-stock-list">
                      {this.props.t("- {this.props.t('My Stock List')}")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/grader-processed-stock-list">
                      {this.props.t("- Processed Stock")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/grader-reassign">
                      {this.props.t("- Re-Assign Screen")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/accepted-process-stock">
                      {this.props.t("- Stock Accepted")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/client-reject-stock">
                      {this.props.t("- Clients Reject Stock")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/grader-profile">
                      {this.props.t("- My Profile")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/grader-update-password">
                      {this.props.t("- Change Password")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#">
                  <i className="bx bxs-user"></i>
                  <span>{this.props.t("Filler")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/filler-dashboard">
                      {this.props.t("- Dashboard")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/filler-edit-verify-accept">
                      {this.props.t("- To Receive & Verify & Accept")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/filler-stock-list">
                      {this.props.t("- {this.props.t('My Stock List')}")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/filler-assign-cube">
                      {this.props.t("- Assigned Belt")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/filler-assign-cube-detail">
                      {this.props.t("- Assigned Belt Details")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/filler-profile">
                      {this.props.t("- My Profile")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/filler-update-password">
                      {this.props.t("- Change Password")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#">
                  <i className="bx bxs-user"></i>
                  <span>{this.props.t("Machine Operator")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/machine-operator-dashboard">
                      {this.props.t("- Dashboard")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/machine-operator-edit-verify-accept">
                      {this.props.t("- To Receive & Verify & Accept")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/machine-operator-cube-list">
                      {this.props.t("- My Belt List")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/machine-operator-assign-cube">
                      {this.props.t("- Assign Belt")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/machine-operator-user-profile">
                      {this.props.t("- My Profile")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/machine-operator-update-password">
                      {this.props.t("- Change Password")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bxs-report"></i>
                  <span>{this.props.t("Reports")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/party-wise-reports">
                      {this.props.t("- Party Wise Report")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/generate-ledger">
                      {this.props.t("- Generate Ledger")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ledger-report">
                      {this.props.t("- Ledger Report")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/party-wise-stock-report">
                      {this.props.t("- Party Wise Stock Report")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/active-person-stock">
                      {this.props.t("- Active Person Stock")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-link-external"></i>
                  <span>{this.props.t("External Unit")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/external-generate-ledger">
                      {this.props.t("- Generate Ledger")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/external-ledger-report">
                      {this.props.t("- Ledger Report")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-transfer"></i>
                  <span>{this.props.t("Transaction History")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/transaction-list">
                      {this.props.t("- Transaction List")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="menu-title">{this.props.t("Apps")}</li>

              <li>
                <Link to="/calendar" className="">
                  <i className="bx bx-calendar" />
                  <span>{this.props.t("Calendar")}</span>
                </Link>
              </li>

              <li>
                <Link to="/chat" className="">
                  <i className="bx bx-chat" />
                  <span>{this.props.t("Chat")}</span>
                </Link>
              </li>
              <li>
                <Link to="/apps-filemanager" className="">
                  <i className="bx bx-file" />
                  <span className="badge rounded-pill bg-success float-end">
                    {this.props.t("New")}
                  </span>
                  <span>{this.props.t("File Manager")}</span>
                </Link>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-store" />
                  <span>{this.props.t("Ecommerce")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/ecommerce-products">
                      {this.props.t("Products")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-product-details/1">
                      {this.props.t("Product Details")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-orders">{this.props.t("Orders")}</Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-customers">
                      {this.props.t("Customers")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-cart">{this.props.t("Cart")}</Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-checkout">
                      {this.props.t("Checkout")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-shops">{this.props.t("Shops")}</Link>
                  </li>
                  <li>
                    <Link to="/ecommerce-add-product">
                      {this.props.t("Add Product")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-bitcoin" />
                  <span>{this.props.t("Crypto")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/crypto-wallet">{this.props.t("Wallet")}</Link>
                  </li>
                  <li>
                    <Link to="/crypto-buy-sell">
                      {this.props.t("Buy/Sell")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/crypto-exchange">
                      {this.props.t("Exchange")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/crypto-lending">{this.props.t("Lending")}</Link>
                  </li>
                  <li>
                    <Link to="/crypto-orders">{this.props.t("Orders")}</Link>
                  </li>
                  <li>
                    <Link to="/crypto-kyc-application">
                      {this.props.t("KYC Application")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/crypto-ico-landing">
                      {this.props.t("ICO Landing")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-envelope"></i>
                  <span>{this.props.t("Email")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/email-inbox">{this.props.t("Inbox")}</Link>
                  </li>
                  <li>
                    <Link to="/email-read">{this.props.t("Read Email")} </Link>
                  </li>
                  <li>
                    <Link to="/#">
                      <span
                        className="badge rounded-pill badge-soft-success float-end"
                        key="t-new"
                      >
                        {this.props.t("New")}
                      </span>
                      <span key="t-email-templates">
                        {this.props.t("Templates")}
                      </span>
                    </Link>
                    <ul className="sub-menu" aria-expanded="false">
                      <li>
                        <Link to="/email-template-basic">
                          {this.props.t("Basic Action")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/email-template-alert">
                          {this.props.t("Alert Email")}{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="/email-template-billing">
                          {this.props.t("Billing Email")}{" "}
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-receipt" />
                  <span>{this.props.t("Invoices")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/invoices-list">
                      {this.props.t("Invoice List")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/invoices-detail">
                      {this.props.t("Invoice Detail")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-briefcase-alt-2" />
                  <span>{this.props.t("Projects")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/projects-grid">
                      {this.props.t("Projects Grid")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects-list">
                      {this.props.t("Projects List")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects-overview">
                      {this.props.t("Project Overview")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects-create">
                      {this.props.t("Create New")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-task" />
                  <span>{this.props.t("Tasks")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/tasks-list">{this.props.t("Task List")}</Link>
                  </li>
                  <li>
                    <Link to="/tasks-kanban">
                      {this.props.t("Kanban Board")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tasks-create">
                      {this.props.t("Create Task")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bxs-user-detail" />
                  <span>{this.props.t("Contacts")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/contacts-grid">{this.props.t("User Grid")}</Link>
                  </li>
                  <li>
                    <Link to="/contacts-list">{this.props.t("User List")}</Link>
                  </li>
                  <li>
                    <Link to="/contacts-profile">
                      {this.props.t("Profile")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#">
                  <span className="badge rounded-pill bg-success float-end">
                    {this.props.t("New")}
                  </span>
                  <i className="bx bxs-detail" />

                  <span>{this.props.t("Blog")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/blog-list">{this.props.t("Blog List")}</Link>
                  </li>
                  <li>
                    <Link to="/blog-grid">{this.props.t("Blog Grid")}</Link>
                  </li>
                  <li>
                    <Link to="/blog-details">
                      {this.props.t("Blog Details")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="menu-title">Pages</li>
              <li>
                <Link to="/#">
                  <i className="bx bx-user-circle" />
                  <span className="badge rounded-pill bg-success float-end">
                    {this.props.t("New")}
                  </span>
                  <span>{this.props.t("Authentication")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/pages-login">{this.props.t("Login")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-login-2">{this.props.t("Login 2")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-register">{this.props.t("Register")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-register-2">
                      {this.props.t("Register 2")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/page-recoverpw">
                      {this.props.t("Recover Password")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/pages-recoverpw-2">
                      {this.props.t("Recover Password 2")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth-lock-screen">
                      {this.props.t("Lock Screen")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth-lock-screen-2">
                      {this.props.t("Lock Screen 2")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/page-confirm-mail">
                      {this.props.t("Confirm Mail")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/page-confirm-mail-2">
                      {this.props.t("Confirm Mail 2")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth-email-verification">
                      {this.props.t("Email Verification")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth-email-verification-2">
                      {this.props.t("Email Verification 2")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth-two-step-verification">
                      {this.props.t("Two Step Verification")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth-two-step-verification-2">
                      {this.props.t("Two Step Verification 2")}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-file" />
                  <span>{this.props.t("Utility")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/pages-starter">
                      {this.props.t("Starter Page")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/pages-maintenance">
                      {this.props.t("Maintenance")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/pages-comingsoon">
                      {this.props.t("Coming Soon")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/pages-timeline">{this.props.t("Timeline")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-faqs">{this.props.t("FAQs")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-pricing">{this.props.t("Pricing")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-404">{this.props.t("Error 404")}</Link>
                  </li>
                  <li>
                    <Link to="/pages-500">{this.props.t("Error 500")}</Link>
                  </li>
                </ul>
              </li>

              <li className="menu-title">{this.props.t("Components")}</li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-tone" />
                  <span>{this.props.t("UI Elements")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/ui-alerts">{this.props.t("Alerts")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-buttons">{this.props.t("Buttons")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-cards">{this.props.t("Cards")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-carousel">{this.props.t("Carousel")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-dropdowns">{this.props.t("Dropdowns")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-offcanvas">{this.props.t("OffCanvas")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-grid">{this.props.t("Grid")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-images">{this.props.t("Images")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-lightbox">{this.props.t("Lightbox")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-modals">{this.props.t("Modals")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-rangeslider">
                      {this.props.t("Range Slider")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-session-timeout">
                      {this.props.t("Session Timeout")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-progressbars">
                      {this.props.t("Progress Bars")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-placeholders">
                      {this.props.t("Placeholders")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-tabs-accordions">
                      {this.props.t("Tabs & Accordions")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-typography">
                      {this.props.t("Typography")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-toasts">{this.props.t("Toasts")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-video">{this.props.t("Video")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-general">{this.props.t("General")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-colors">{this.props.t("Colors")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-rating">{this.props.t("Rating")}</Link>
                  </li>
                  <li>
                    <Link to="/ui-notifications">
                      {this.props.t("Notifications")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ui-breadcrumb">
                      {this.props.t("Breadcrumb")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#">
                  <i className="bx bxs-eraser" />
                  <span className="badge rounded-pill bg-danger float-end">
                    10
                  </span>
                  <span>{this.props.t("Forms")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/form-elements">
                      {this.props.t("Form Elements")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-layouts">
                      {this.props.t("Form Layouts")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-validation">
                      {this.props.t("Form Validation")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-advanced">
                      {this.props.t("Form Advanced")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-editors">
                      {this.props.t("Form Editors")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-uploads">
                      {this.props.t("Form File Upload")}{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-xeditable">
                      {this.props.t("Form Xeditable")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-repeater">
                      {this.props.t("Form Repeater")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/form-wizard">{this.props.t("Form Wizard")}</Link>
                  </li>
                  <li>
                    <Link to="/form-mask">{this.props.t("Form Mask")}</Link>
                  </li>
                  <li>
                    <Link to="/dual-listbox">
                      {this.props.t("Transfer List")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-list-ul" />
                  <span>{this.props.t("Tables")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/tables-basic">
                      {this.props.t("Basic Tables")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tables-datatable">
                      {this.props.t("Data Tables")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tables-responsive">
                      {this.props.t("Responsive Table")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tables-editable">
                      {this.props.t("Editable Table")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/tables-dragndrop">
                      {this.props.t("Drag & Drop Table")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bxs-bar-chart-alt-2" />
                  <span>{this.props.t("Charts")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/apex-charts">{this.props.t("Apex charts")}</Link>
                  </li>
                  <li>
                    <Link to="/chartist-charts">
                      {this.props.t("Chartist Chart")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/chartjs-charts">
                      {this.props.t("Chartjs Chart")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/e-charts">{this.props.t("E Chart")}</Link>
                  </li>
                  <li>
                    <Link to="/sparkline-charts">
                      {this.props.t("Sparkline Chart")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/charts-knob">{this.props.t("Knob Chart")}</Link>
                  </li>
                  <li>
                    <Link to="/re-charts">{this.props.t("Re Chart")}</Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-aperture" />
                  <span>{this.props.t("Icons")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/icons-boxicons">{this.props.t("Boxicons")}</Link>
                  </li>
                  <li>
                    <Link to="/icons-materialdesign">
                      {this.props.t("Material Design")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/icons-dripicons">
                      {this.props.t("Dripicons")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/icons-fontawesome">
                      {this.props.t("Font awesome")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-map" />
                  <span>{this.props.t("Maps")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/maps-google">{this.props.t("Google Maps")}</Link>
                  </li>
                  <li>
                    <Link to="/maps-vector">{this.props.t("Vector Maps")}</Link>
                  </li>
                  <li>
                    <Link to="/maps-leaflet">
                      {this.props.t("Leaflet Maps")}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-share-alt" />
                  <span>{this.props.t("Multi Level")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="true">
                  <li>
                    <Link to="#">{this.props.t("Level 1.1")}</Link>
                  </li>
                  <li>
                    <Link to="#" className="has-arrow">
                      {this.props.t("Level 1.2")}
                    </Link>
                    <ul className="sub-menu" aria-expanded="true">
                      <li>
                        <Link to="#">{this.props.t("Level 2.1")}</Link>
                      </li>
                      <li>
                        <Link to="#">{this.props.t("Level 2.2")}</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li> */}
            </ul>
          </div>
          <div className="text-white position-relative bottom-0 text-center w-100">
            V &nbsp; 1 . 0
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
};

export default withRouter(withTranslation()(SidebarContent));
